import styled from "styled-components";

export const ResponsiveContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  flex: 1;
  
  @media (max-width: 768px) {
    padding: 0 18px;
  }
  
  @media (max-width: 576px) {
    padding: 0 16px;
  }
  
  @media (max-width: 480px) {
    padding: 0 ;
  }
`;
